// import Router from 'next/router';
// import React, { useEffect } from 'react';

import SettingsOrganizationPage from '~/pages/settings/organization';

// const SettingsIndex = () => {
//   useEffect(() => {
//     Router.replace('/settings/organization');
//   }, []);

//   return <SettingsOrganizationPage />;
// };

export default SettingsOrganizationPage;
